/**
 * Asynchronously loads the component for App Project page
 */

import React from 'react'
import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "AiAppProjectPage" */ './index'), {
  fallback: <LoadingPage />
})
